<template>
  <div
    class="add-to-cart-btn"
    :class="{ 'is-loading': loading }"
    @click.stop.prevent="$emit('click')"
  >
    <svg v-if="loading" class="spinner" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" />
    </svg>
    <svg v-else class="basket-icon" viewBox="0 0 24 24">
      <use xlink:href="/static/img/icons.svg#basket"></use>
    </svg>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  loading?: boolean;
}>();

defineEmits<{
  click: [];
}>();
</script>

<style scoped lang="scss">
.add-to-cart-btn {
  cursor: pointer;
  border: 1px solid currentColor;
  border-radius: 8px;
  padding: 4px;
  line-height: 0;
  color: var(--q-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, opacity 0.15s ease;

  // GPU ускорение
  transform: translateZ(0);
  will-change: transform;

  &:active {
    transform: scale(0.95) translateZ(0);
  }

  &.is-loading {
    pointer-events: none;
  }
}

.basket-icon,
.spinner {
  width: 1em;
  height: 1em;
  fill: currentColor;
  display: block;
}

.spinner {
  animation: spin 0.8s linear infinite;

  circle {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-dasharray: 50;
    stroke-dashoffset: 25;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
